var map = {
	"./logo_css.svg": 7538,
	"./logo_gulp.svg": 2048,
	"./logo_gulp_white.svg": 4561,
	"./logo_html.svg": 6394,
	"./logo_jenkins.svg": 2767,
	"./logo_lambda.svg": 3049,
	"./logo_react.svg": 1213,
	"./logo_vue.svg": 6604
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8138;